import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router'

/** Global search: submits to the search screen, or jumps straight to an app for a numeric App Store id. */
export function SearchBox() {
	const [q, setQ] = useState('')
	const navigate = useNavigate()
	function submit(e: FormEvent) {
		e.preventDefault()
		const term = q.trim()
		if (!term) return
		navigate(/^\d+$/.test(term) ? `/apps/${term}` : `/search?q=${encodeURIComponent(term)}`)
	}
	return (
		<form className="nav-search" role="search" onSubmit={submit}>
			<input
				type="search"
				placeholder="Search apps or ids"
				aria-label="Search apps"
				value={q}
				onChange={(e) => setQ(e.target.value)}
			/>
		</form>
	)
}
